/**
 *
 * HowItWorksChooseFund
 */
import { Box, Typography } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { homeStyles } from './home-styles';

export default function HowItWorksChooseItemsToDonate() {
  return (
    <div>
      <Box sx={homeStyles.icons}>
        <AddShoppingCartIcon fontSize="large" />
      </Box>
      <Typography
        color="primary"
        component="h5"
        variant="h5"
        sx={homeStyles.titles}
      >
        Select items to donate.
      </Typography>

      <Typography paragraph variant="body1" sx={homeStyles.descriptions}>
        Add items to the cart that you want to donate.
      </Typography>
    </div>
  );
}
